__turbopack_context__.v({
  "brand": "site-chrome-module__fHi7Fa__brand",
  "dark": "site-chrome-module__fHi7Fa__dark",
  "footer": "site-chrome-module__fHi7Fa__footer",
  "header": "site-chrome-module__fHi7Fa__header",
  "mark": "site-chrome-module__fHi7Fa__mark",
  "signIn": "site-chrome-module__fHi7Fa__signIn",
  "skip": "site-chrome-module__fHi7Fa__skip",
});
